import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, InlineFetchError, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
      </Heading>
      {/* On a fetch error, show the branded error notice instead of the list — never both, so the
          empty state can't surface under an error (reviews is [] in that case). */}
      {fetchReviewsError ? (
        <InlineFetchError messageId="ListingPage.reviewsError" />
      ) : (
        <Reviews reviews={reviews} />
      )}
    </section>
  );
};

export default SectionReviews;
